/**
 * What the run page reads beyond the mission: the landing queue's landing for its branch. Live:
 * state.ext.landing. Demo (?mock=1): the Pipelines demo data plus the demo missions' own landings
 * (run/mock.ts), kept out of the landing slice so the Pipelines page reads as before.
 */
import { useMemo } from 'react';
import type { Landing } from '@orgus/protocol';
import { useOrgus } from '../../../lib/store.ts';
import { useLandingSlice } from '../../landing/api.ts';
import { demoMissionLandings } from './mock.ts';
import { missionLanding } from './model.ts';

/** The newest landing submitted for this mission, or null (no landing module, or none submitted). */
export function useMissionLanding(missionId: string, now: number): Landing | null {
  const slice = useLandingSlice();
  const mock = useOrgus((s) => s.mode === 'mock');
  // The demo landings are made once per mission page; `now` moves every few seconds.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const demo = useMemo(() => (mock ? demoMissionLandings(now) : []), [mock, missionId]);
  return useMemo(() => missionLanding([...(slice?.landings ?? []), ...demo], missionId), [slice, demo, missionId]);
}
